import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import callAPI from '../../../../helpers/callAPI'
import ReportTable from '../../../../templates/ReportTable/ReportTable'
import Loading from '../../../../templates/UI/Loading/Loading'

export default function CountryBlacklists({ showSystemMessage, data, dataLoaded, refetch, setIsEdit, setIsOpen }) {
  
    const [deleteIndex, setDeleteIndex] = useState(-1)

    const deleteBlacklist = async (countryCode) => {
        const response = await callAPI(`compliance/blacklist/country/${countryCode}`, 'DELETE', {}, [])
        if (response.success) {
            showSystemMessage('success', 'Email address deleted successfully')
            setDeleteIndex(-1)
            refetch()
        } else {
            showSystemMessage('error', response.errors.message)
            setDeleteIndex(-1)
        }
    }

    const openEditModal = (blacklist) => {
        setIsEdit(blacklist)
        setIsOpen(true)

    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Country Code',
                accessor: 'country_code',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Country',
                accessor: 'country',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ value }) => {
                    return <>{value}</>
                }
            },
            {
                Header: '',
                accessor: 'blacklists',
                className: 'text-center',
                Cell: (tableData) => {
                    let index = tableData.row.index

                    return (<>
                        <button className='btn btn-warning btn-sm mr-2' onClick={() => { openEditModal(tableData.data[tableData.row.index]) }}>Edit</button>
                        {(index === deleteIndex ?
                            <button className='btn btn-danger btn-sm' onClick={() => deleteBlacklist(tableData.data[tableData.row.index].country_code)}>Confirm Delete</button>
                            :
                            <button className='btn btn-outline-danger btn-sm' onClick={() => setDeleteIndex(tableData.row.index)}>Delete</button>
                        )}
                    </>
                    )
                }
            }
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.blacklist} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <Card className="mb-3">
            <Card.Header className="d-flex justify-content-between align-items-center">Country Blacklists</Card.Header>
            {dataLoaded ?
                getReportOutput()
                : (
                    <Loading />
                )}
        </Card>
    )
}
